import { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction | null = null;

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const redirectToLogin = () => {
  if (navigate) {
    navigate("/login");
  }
};
